import { createAction, props } from '@ngrx/store';
import { IntegratedAppComponentType } from '@pcp/core/interfaces';

export const requestOpenExtensionApp = createAction(
    '[PcpExtensionApp] Request open ExtensionApp',
    props<{ extensionApp: IntegratedAppComponentType }>(),
);

export const openExtensionAppSuccess = createAction(
    '[PcpExtensionApp] Open ExtensionApp success',
    props<{ extensionApp: IntegratedAppComponentType }>(),
);

export const openExtensionAppDenied = createAction(
    '[PcpExtensionApp] Open ExtensionApp denied',
    props<{ extensionApp: IntegratedAppComponentType }>(),
);

export const closeExtensionApp = createAction('[PcpExtensionApp] Close ExtensionApp');
